import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, getCurrentInstance } from 'vue';

import { getFeatureFlag, isGtm1216PriorityPassLoungesCollinsonIntegrationEnabled } from '@white-label-plugin/launch-darkly';
// Types
import type { EntryMethod } from '@white-label-types/parking-booking';

// Constants
import {
  BARRIER_ACCESS_TYPES,
  NAMED_ROUTES,
  PRODUCT_TYPES,
  FEATURE_FLAGS,
} from '@white-label-configuration/constants';

// Components
import BTicketGuests from '../../b-ticket-guests/b-ticket-guests.vue';
import BTicketPrivateLounge from '../../b-ticket-private-lounge-details/b-ticket-private-lounge-details.vue';
import AddToSmartWalletButton from '../../add-to-smart-wallet-button/add-to-smart-wallet-button.vue';

// Helpers
import { getDomainUrl, DOMAINS_NAMES } from '@white-label-helper/switch-app';
import { getAppHeroProduct } from '@white-label-helper/get-app-hero-product';

// getCurrentInstance needed to access global $t property
// as its not possible with current vue version
// info found in navbar-tabs.vue comment from Patrycja Gawlas

export default /*#__PURE__*/_defineComponent({
  __name: 'b-ticket-access-info-lounges-fasttrack',
  props: {
  accessInfo: {
    type: [Object, String],
    required: true,
  },
  accessInfoFromEntranceInfo: {
    type: Boolean,
    default: false,
  },
  subItems: {
    type: Array,
    default: () => [],
  },
  hideViewTicketsButton: {
    type: Boolean,
    default: false,
  },
  showProviderLogo: {
    type: Boolean,
    default: false,
  },
  product: {
    type: Object,
    required: false,
    default: ()=> {},
  },
  extendedFlow: {
    type: Boolean,
    default: false,
  }
},
  setup(__props, { expose }) {

const props = __props;

const instance = getCurrentInstance();
const vm = instance?.proxy as Vue;



const ticketAccessInfo = ref({});

if(typeof props.accessInfo === 'string'){
  ticketAccessInfo.value = {value : props.accessInfo}
} else {
  ticketAccessInfo.value = props.accessInfo;
}

const isTimeslotProduct = ref(getFeatureFlag(FEATURE_FLAGS.NGQ_11_TIMESLOT));
const showSmartWallet = ref(getFeatureFlag(FEATURE_FLAGS.NGQ_344_SMART_WALLET));

const isFasttrackProduct = ref(getAppHeroProduct('parking') === 'fasttrack');

const downloadToken = computed(() => props.product?.details?.download_token);

const ticketDownloadLink = computed(() => {
  if(hasUrlEntryMethod.value && urlEntryMethodLink.value) {
    return urlEntryMethodLink.value;
  }

  if (downloadToken.value) {
    const url = new URL(getDomainUrl(DOMAINS_NAMES.ACCOUNT)!);
    const searchParams = new URLSearchParams({token: downloadToken.value});

    url.pathname = NAMED_ROUTES.downloads.ticket;
    searchParams.forEach((value, key) => url.searchParams.set(key, value));

    return url.toString();
  }
  return '';
});

const hasTicketDownloadLink = computed(() => ticketDownloadLink.value?.length > 0);

const formattedAccessType = computed(() => {
  return typeof props.accessInfo === 'string'
    ? props.accessInfo.toLowerCase()
    : props.accessInfo?.['type']?.toLowerCase();
});

const displayImg = computed(() => typeof props.accessInfo !== 'string' && props.accessInfo['type'] === BARRIER_ACCESS_TYPES.QRCODE);

const isExtrasProduct = computed(() => props.product?.['product_code'] === PRODUCT_TYPES.EXTRAS);

const accessInfoTitle = computed(() => {
  if (isPriorityPassProduct.value) return vm.$t('UI.ticket.accessVoucher.title');
  if (isExtrasProduct.value) return vm.$t('UI.ticket.accessExtrasTitle');
  return vm.$t(
    (props.product?.['productOption'] === 'lounge_private' ||
    props.product?.['inventory_item']?.product_option.code === 'lounge_private')
    ? 'UI.ticket.privateLoungeAccessTitle'
    : 'UI.ticket.accessLoungeTitle'
  );
});

const isPrivateLounge = computed(() => {
  return (
    (props.product &&
      (props.product?.['productOption'] === 'lounge_private' ||
        props.product?.['inventory_item']?.product_option.code === 'lounge_private')) ||
    props.product?.['inventoryItem']?.product_option.code === 'lounge_private'
  );
});

const urlEntryMethod = computed<EntryMethod | undefined>(() => {
  return props.product?.entry_methods?.find(
    (method: EntryMethod) => method?.['entryMethod']?.type.toLowerCase() === 'url'
  );
});

const hasUrlEntryMethod = computed(() => !!urlEntryMethod.value);

const urlEntryMethodLink = computed(() => urlEntryMethod.value?.['entryMethod']?.value);

const isPriorityPassProduct = computed(() => isGtm1216PriorityPassLoungesCollinsonIntegrationEnabled() && props.product?.['inventory_item']?.additional_fields.additional_passengers !== undefined);

const gaViewTicketsButtonLabel = computed(() => {
  if (isPriorityPassProduct.value) return 'GAViewLoungePassTicketsButton';
  return 'GAViewTicketsButton';
});

expose({
  ticketAccessInfo,
  isTimeslotProduct,
  showSmartWallet,
  downloadToken,
  ticketDownloadLink,
  formattedAccessType,
  displayImg,
  isExtrasProduct,
  accessInfoTitle,
  isPrivateLounge,
  isFasttrackProduct,
});


return { __sfc: true,instance, vm, props, ticketAccessInfo, isTimeslotProduct, showSmartWallet, isFasttrackProduct, downloadToken, ticketDownloadLink, hasTicketDownloadLink, formattedAccessType, displayImg, isExtrasProduct, accessInfoTitle, isPrivateLounge, urlEntryMethod, hasUrlEntryMethod, urlEntryMethodLink, isPriorityPassProduct, gaViewTicketsButtonLabel, BTicketGuests, BTicketPrivateLounge, AddToSmartWalletButton }
}

})